import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { googleAnalyticsGtag } from  './app/shared/helpers/google-analytics-gtag';
import { GoogleAnalyticsSingleID } from "./environments/GoogleAnalyticsIDs";
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  console.log(environment.apiUrl);
}

googleAnalyticsGtag(GoogleAnalyticsSingleID);
platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], });
